import queueMicrotask from 'queue-microtask'

/**
 * @param callback
 */
export default function queueMicrotaskPerfUtil (callback) {
  return queueMicrotask(callback)
}
